import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { OrderDocument } from '@my-account/const';
import { DocumentDownloadButtonComponent } from '../document-download-button';

@Component({
  selector: 'sd-order-documents-table',
  templateUrl: './order-documents-table.component.html',
  styleUrls: ['./order-documents-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgForOf, NgIf, DatePipe, DocumentDownloadButtonComponent],
})
export class OrderDocumentsTableComponent implements OnInit {
  skeletonRows: void[] = [];
  skeletonColumns: void[] = [];

  @Input() items: OrderDocument[];
  @Input() loading: boolean;
  @Input() pageSize: number;

  ngOnInit(): void {
    this.skeletonRows = Array.from({ length: this.pageSize });
    this.skeletonColumns = Array.from({ length: 5 });
  }
}
